import React, { Component } from "react";
import "./styles.css";
import CountUp from "react-countup";

class PriceTicker extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.speed  = 0.25;
    this.start  = 0;
    this.target = 0;
  }



  // ===============================================================================================
  render() {
    // ---------------------------------------------------------------------------------------------
    let config = {  // Needs x100 input value
      decimals: 2,
      decimal:  ".",
      prefix:   "$",
    }

    if (this.props.type === "major") {  // Needs x100 input value
      config = {
        decimals: 0,
        decimal:  "",
        prefix:   "",
      }
    }
    else if (this.props.type === "minor") {  // Needs x10 input value
      config = {
        decimals: 1,
        decimal:  "",
        prefix:   "",
      }
    }



    // ---------------------------------------------------------------------------------------------
    if (this.ticker && this.props.target !== this.target) {
      this.target = this.props.target;
      let span = this.ticker.spanElement;
      let cur = (span.innerHTML).replace("$", "").replace(".", "");
      let num = parseInt(cur, 10);

      // Get the current number to transition from
      this.start = num;
      if (this.props.type === "major") {
        this.start = num * 100;
      }
      else if (this.props.type === "minor") {
        this.start = num * 10;
      }
    }



    // ---------------------------------------------------------------------------------------------
    return (
      <CountUp
        ref={(ele) => { this.ticker = ele; }}
        className="ticker"
        start={(this.start / 100)}
        end={(this.target / 100)}
        duration={this.speed}
        useEasing={false}
        useGrouping={true}
        separator=","
        decimals={config.decimals}
        decimal={config.decimal}
        prefix={config.prefix}
      />
    );
  }

}



export default PriceTicker
